import {ChangeDetectorRef, Component, computed, inject, OnInit, PLATFORM_ID, signal, ViewChild} from '@angular/core';
import {CarouselModule} from 'primeng/carousel';
import {ButtonModule} from 'primeng/button';
import {isPlatformBrowser, NgClass, NgOptimizedImage, NgStyle, NgTemplateOutlet} from '@angular/common';
import {FullCalendarModule} from '@fullcalendar/angular';
import {InputTextModule} from 'primeng/inputtext';
import {FormsModule} from '@angular/forms';
import {Router} from '@angular/router';
import {EventTestFacade} from '../event/services/event-test-facade.service';
import {EventRepository} from '../event/services/event-repository';
import {ActivitySearcherComponent} from '../activity/ui/activity-searcher/activity-searcher.component';
import {EventCalendarComponent} from '../event/event-calendar/event-calendar.component';
import {ActivityFacade} from '../activity/store/activity.facade';
import {coalesce, FetchRequest} from '@abydos-angular/core';
import {FulfillmentListComponent} from '../fulfillment-list/fulfillment-list.component';
import {AuthFacade} from '@abydos-angular/rest-api';
import {ConfirmationService, MessageService} from 'primeng/api';
import {ConfirmDialog} from 'primeng/confirmdialog';
import {BaseFormDialogComponent, DialogBodyDirective} from '@abydos-angular/form';
import {ApplicationEditedDataComponent} from '../application/edited-data/application-edited-data.component';
import {PayloadWithRequestId} from '@abydos-angular/store';
import {ApplicationVO} from '../rest-api/application/store/application.interfaces';
import {EventVO} from '../event/store/event.interfaces';
import {ActivityVO} from '../activity/store/activity.interfaces';
import {first} from 'rxjs';
import {Skeleton} from 'primeng/skeleton';
import {EnvironmentInjectionToken} from '../app.config';

@Component({
    selector: 'app-landing-page',
    imports: [CarouselModule, ButtonModule, NgStyle, NgTemplateOutlet, NgClass, FullCalendarModule, InputTextModule, FormsModule,
        ActivitySearcherComponent, EventCalendarComponent, FulfillmentListComponent, ConfirmDialog, BaseFormDialogComponent, DialogBodyDirective, ApplicationEditedDataComponent, NgOptimizedImage, Skeleton],
    templateUrl: './landing-page.component.html',
    standalone: true,
    styleUrl: './landing-page.component.scss',
    providers: [EventTestFacade, EventRepository]
})
export class LandingPageComponent implements OnInit {
    @ViewChild('eventDataDialog', {static: true}) eventDataDialog: BaseFormDialogComponent | undefined;
    environment = inject(EnvironmentInjectionToken);
    selectedEvent: EventVO | undefined;
    private platformId = inject(PLATFORM_ID);
    isBrowser = isPlatformBrowser(this.platformId);
    activityList = signal<ActivityVO[]>([]);
    activityListSlideSHow = computed(() => this.activityList().filter(activity => activity.slideshowImage !== null))

    buttonDetails = [
        {
            backgroundColor: '#ffeac3',
            icon: 'pi pi-calendar',
            title: 'Naptár nézet',
            text: 'Keressen a naptárban a meghirdetett események között!',
            action: () => {
                this.view = 'calendar';
            }
        },
        {
            backgroundColor: '#fdd384',
            icon: 'pi pi-megaphone',
            title: 'Szolgáltatás keresése',
            text: 'Keressen a szervezetek által meghírdetett események között',
            action: () => this.view = 'activitySearcher' // this.dialogVisible = true
        },
        {
            backgroundColor: '#febf49',
            icon: 'pi pi-thumbtack',
            title: 'Jelentkezések',
            text: 'Azon események listája, amikre jelentkezett',
            action: () => this.fulfillmentViewCLicked('greaterOrEqual')
        },
        {
            backgroundColor: '#ffab0d',
            icon: 'pi pi-check-circle',
            title: 'Teljesítések',
            text: 'Tekintse meg, milyen eseményeken vett részt, mennyi órát teljesítve azzal',
            action: () => this.fulfillmentViewCLicked('lessOrEqual')
            // action: () => this.router.navigateByUrl('fulfillment-list').then()
        },
    ];

    selectedTableView: string = '';
    selectedActivity: ActivityVO | undefined;
    public view = 'main'

    constructor(private changeDetector: ChangeDetectorRef, private router: Router, private activityFacade: ActivityFacade,
                public authFacade: AuthFacade, private messageService: MessageService, private confirmationService: ConfirmationService) {
    }

    ngOnInit() {
        const request = new FetchRequest<any>()
        request.criteria = {
            baseCriteria: [
                {fieldName: 'slideshowImage', operator: 'notNull'}
            ]
        };
        this.activityFacade.list(request, result => {
            this.activityList.set(coalesce(result.getData(), [])!)
        })
    }

    activitySelected(activity: ActivityVO | undefined) {
        this.authFacade.isUserLoggedIn.subscribe(isUserLoggedIn => {
            if (isUserLoggedIn) {
                this.selectedActivity = activity;
                this.selectedEvent = undefined;
                this.eventDataDialog?.showNewDialog();
            } else {
                this.confirmLogin()
            }
        })
    }

    eventSelected(event: EventVO) {
        this.authFacade.isUserLoggedIn.pipe(first()).subscribe(isUserLoggedIn => {
            if (isUserLoggedIn) {
                this.selectedEvent = event
                this.selectedActivity = event.activity;
                this.eventDataDialog?.showNewDialog();
            } else {
                this.confirmLogin()
            }
        })
    }

    confirmLogin() {
        // console.log(this.confirmationService)
        this.confirmationService.confirm({
            key: 'yes_no_only',
            header: 'Bejelentkezés szükséges!',
            icon: 'pi pi pi-question-circle',
            message: 'Ehhez a funkcióhoz be kell lépned a felhasználói fiókodba!\n\nSzeretnél most bejelentkezni?',
            accept: () => {
                this.router.navigateByUrl('login').then();
            }
        });
    }

    fulfillmentViewCLicked(type: string) {
        this.selectedTableView = type;
        if (this.authFacade.isTokenPresent()) { // ha jó lesz az IsUserLoggedIn akkor az kell ide
            this.view = '';
            this.view = 'fulfillmentList'
        } else {
            this.confirmLogin();
        }
    }


    activityBannerClicked(menu: ActivityVO) {
        this.activitySelected(menu)
    }

    editedDataSaved(payload: PayloadWithRequestId<ApplicationVO>) {
        if (payload?.metadata?.saveAndNewInProgress) {
            // Ment és új van folyamatban, nincs mit csinálni
        } else {
            this.eventDataDialog!.closeDialog();
        }
    }
}
